import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'
import { QueryKeys } from './_query_keys'

export const useCustomCheckout = (
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'

  return useQuery({
    queryKey: [QueryKeys.CUSTOM_CHECKOUT],
    queryFn: () =>
      HttpRequest({
        url: APIEndpoints.CustomCheckoutTemplateConfig,
        method,
      }),
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  })
}

export const useCreateCustomCheckout = (options?: any) => {
  const method = 'POST'

  return useMutation(
    ({ data }: { data: any }) =>
      HttpRequest({
        url: APIEndpoints.CustomCheckoutTemplateConfig,
        method,
        data,
      }),
    options
  )
}

export const useUpdateCustomCheckout = (options?: any) => {
  const method = 'PUT'

  return useMutation(
    ({ data, id }: { data: any; id: string | number }) =>
      HttpRequest({
        url: `${APIEndpoints.CustomCheckoutTemplateConfig}/${id}`,
        method,
        data,
      }),
    options
  )
}

export const usePaymentMethods = (
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'

  return useQuery({
    queryKey: [QueryKeys.CUSTOM_CHECKOUT, 'payment-methods'],
    queryFn: () =>
      HttpRequest({
        url: APIEndpoints.PaymentMethod,
        method,
      }),
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  })
}

export const useUpdatePaymentMethods = (options?: any) => {
  const method = 'PUT'

  return useMutation(
    ({ data }: { data: any }) =>
      HttpRequest({
        url: APIEndpoints.PaymentMethod,
        method,
        data,
      }),
    options
  )
}

export const usePaymentFailureTemplates = (
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'

  return useQuery({
    queryKey: [QueryKeys.CUSTOM_CHECKOUT, 'payment-failure-templates'],
    queryFn: () =>
      HttpRequest({
        url: APIEndpoints.PaymentFailureTemplate,
        method,
      }),
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  })
}

export const useUpdatePaymentFailureTemplates = (options?: any) => {
  const method = 'PUT'

  return useMutation(
    ({ data }: { data: any }) =>
      HttpRequest({
        url: APIEndpoints.PaymentFailureTemplate,
        method,
        data,
      }),
    options
  )
}
